(() => {
  if (window.jdDiagnosticLeadBridgeReady) return;
  window.jdDiagnosticLeadBridgeReady = true;

  const CHAT_ENDPOINT_MARKER = 'businessDiagnosticChat';
  const TRANSCRIBE_ENDPOINT = 'https://us-central1-leadfinder-web-jd.cloudfunctions.net/businessDiagnosticTranscribe';
  const MAX_RECORDING_MS = 120000;
  const originalFetch = window.fetch.bind(window);
  const ROTATING_WORDS = ['mejorar', 'crear', 'integrar', 'optimizar', 'resolver', 'automatizar'];
  let sessionId = createSessionId();

  function createSessionId() {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
    const random = window.crypto?.getRandomValues
      ? Array.from(window.crypto.getRandomValues(new Uint32Array(4)), (n) => n.toString(16)).join('')
      : Math.random().toString(36).slice(2) + Date.now().toString(36);
    return `jd_${Date.now().toString(36)}_${random}`.slice(0, 80);
  }

  function clientContext() {
    const params = new URLSearchParams(window.location.search);
    return {
      page_url: window.location.href.slice(0, 1000),
      referrer: document.referrer.slice(0, 1000),
      locale: (document.documentElement.lang || navigator.language || '').slice(0, 40),
      utm_source: (params.get('utm_source') || '').slice(0, 160),
      utm_medium: (params.get('utm_medium') || '').slice(0, 160),
      utm_campaign: (params.get('utm_campaign') || '').slice(0, 200),
      utm_term: (params.get('utm_term') || '').slice(0, 200),
      utm_content: (params.get('utm_content') || '').slice(0, 200),
    };
  }

  window.fetch = async (input, init = {}) => {
    const url = typeof input === 'string' ? input : input?.url || '';
    const method = String(init?.method || 'GET').toUpperCase();
    if (method === 'POST' && url.includes(CHAT_ENDPOINT_MARKER) && typeof init.body === 'string') {
      try {
        const payload = JSON.parse(init.body);
        if (Array.isArray(payload?.messages)) {
          payload.session_id = sessionId;
          payload.client_context = clientContext();
          init = { ...init, body: JSON.stringify(payload) };
        }
      } catch (_) {}
    }
    return originalFetch(input, init);
  };

  function installPrivacyNote(root) {
    if (!root || root.querySelector('[data-chat-privacy-note]')) return;
    const shell = root.querySelector('[data-chat-shell]');
    if (!shell) return;
    const note = document.createElement('p');
    note.className = 'jd-diagnostic__privacy-note';
    note.setAttribute('data-chat-privacy-note', '');
    note.appendChild(document.createTextNode('Si compartes datos de contacto, se usarán únicamente para dar seguimiento a tu diagnóstico. El marketing requiere tu autorización. '));
    const link = document.createElement('a');
    link.href = '/policies/privacy-policy';
    link.textContent = 'Aviso de Privacidad';
    note.appendChild(link);
    shell.appendChild(note);
  }

  function installPrivacyNotes(scope = document) {
    if (scope.matches?.('[data-jd-diagnostic]')) installPrivacyNote(scope);
    scope.querySelectorAll?.('[data-jd-diagnostic]').forEach(installPrivacyNote);
  }

  function installHeadingAnimation(root) {
    if (!root || root.dataset.jdRotatingHeadingReady === 'true') return;
    const heading = root.querySelector('.jd-diagnostic__heading');
    if (!heading) return;
    root.dataset.jdRotatingHeadingReady = 'true';

    const lineOne = document.createElement('span');
    lineOne.className = 'jd-diagnostic__heading-line jd-diagnostic__heading-line--one';
    const prefix = document.createElement('span');
    prefix.className = 'jd-diagnostic__heading-prefix';
    prefix.textContent = '¿Qué te gustaría';

    const wordSlot = document.createElement('span');
    wordSlot.className = 'jd-diagnostic__rotating-slot';
    const sizer = document.createElement('span');
    sizer.className = 'jd-diagnostic__rotating-sizer';
    sizer.textContent = 'automatizar';
    sizer.setAttribute('aria-hidden', 'true');
    const word = document.createElement('span');
    word.className = 'jd-diagnostic__rotating-word';
    word.textContent = ROTATING_WORDS[0];
    word.setAttribute('aria-hidden', 'true');
    wordSlot.append(sizer, word);

    const lineTwo = document.createElement('span');
    lineTwo.className = 'jd-diagnostic__heading-line jd-diagnostic__heading-line--two';
    lineTwo.textContent = 'en tu negocio?';

    lineOne.append(prefix);
    heading.textContent = '';
    heading.append(lineOne, wordSlot, lineTwo);
    heading.setAttribute('aria-label', '¿Qué te gustaría mejorar, crear, integrar, optimizar, resolver o automatizar en tu negocio?');

    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;

    let index = 0;
    const isAlive = () => document.documentElement.contains(word);
    const erase = () => {
      if (!isAlive()) return;
      const text = word.textContent || '';
      if (text.length) {
        word.textContent = text.slice(0, -1);
        window.setTimeout(erase, 48);
        return;
      }
      index = (index + 1) % ROTATING_WORDS.length;
      window.setTimeout(typeNext, 180);
    };
    const typeNext = () => {
      if (!isAlive()) return;
      const target = ROTATING_WORDS[index];
      const length = (word.textContent || '').length;
      if (length < target.length) {
        word.textContent = target.slice(0, length + 1);
        window.setTimeout(typeNext, 72);
        return;
      }
      window.setTimeout(erase, 1500);
    };
    window.setTimeout(erase, 1600);
  }

  function installHeadingAnimations(scope = document) {
    if (scope.matches?.('[data-jd-diagnostic]')) installHeadingAnimation(scope);
    scope.querySelectorAll?.('[data-jd-diagnostic]').forEach(installHeadingAnimation);
  }

  function supportedMimeType() {
    if (!window.MediaRecorder?.isTypeSupported) return '';
    const candidates = [
      'audio/webm;codecs=opus',
      'audio/mp4',
      'audio/webm',
      'audio/ogg;codecs=opus',
    ];
    return candidates.find((type) => MediaRecorder.isTypeSupported(type)) || '';
  }

  function blobToBase64(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = String(reader.result || '');
        resolve(result.includes(',') ? result.split(',').pop() : result);
      };
      reader.onerror = () => reject(reader.error || new Error('file_read_failed'));
      reader.readAsDataURL(blob);
    });
  }

  function setVoiceStatus(root, message, isError = false) {
    const status = root.querySelector('[data-chat-status]');
    if (!status) return;
    if (!message) {
      status.hidden = true;
      status.textContent = '';
      status.classList.remove('jd-diagnostic__status--error');
      return;
    }
    status.textContent = message;
    status.hidden = false;
    status.classList.toggle('jd-diagnostic__status--error', isError);
  }

  function installVoiceInput(root) {
    if (!root || root.dataset.jdVoiceReady === 'true') return;
    const form = root.querySelector('[data-chat-form]');
    const input = root.querySelector('[data-chat-input]');
    const send = root.querySelector('[data-chat-send]');
    if (!form || !input || !send) return;
    root.dataset.jdVoiceReady = 'true';

    if (!navigator.mediaDevices?.getUserMedia || !window.MediaRecorder) return;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'jd-diagnostic__mic';
    button.setAttribute('data-chat-mic', '');
    button.setAttribute('aria-label', 'Dictar mensaje');
    button.setAttribute('title', 'Dictar mensaje');
    form.insertBefore(button, input);

    let recorder = null;
    let stream = null;
    let chunks = [];
    let startedAt = 0;
    let timeoutId = null;
    let processing = false;
    let sendWasDisabled = false;

    const cleanupStream = () => {
      if (timeoutId) window.clearTimeout(timeoutId);
      timeoutId = null;
      stream?.getTracks?.().forEach((track) => track.stop());
      stream = null;
    };

    const setBusy = (busy) => {
      processing = busy;
      button.disabled = busy;
      if (busy) {
        sendWasDisabled = send.disabled;
        send.disabled = true;
      } else if (!sendWasDisabled) {
        send.disabled = false;
      }
    };

    const finishRecording = () => {
      if (recorder && recorder.state === 'recording') recorder.stop();
    };

    const transcribe = async (blob, durationMs) => {
      if (!blob?.size) return;
      setBusy(true);
      button.classList.remove('is-recording');
      button.classList.add('is-transcribing');
      button.setAttribute('aria-label', 'Transcribiendo audio');
      setVoiceStatus(root, 'Transcribiendo…');

      try {
        const audioBase64 = await blobToBase64(blob);
        const response = await originalFetch(TRANSCRIBE_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            audio_base64: audioBase64,
            mime_type: blob.type || 'audio/webm',
            duration_ms: Math.min(durationMs, MAX_RECORDING_MS),
            session_id: sessionId,
          }),
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok || !data?.text) throw new Error(data?.error || 'transcription_failed');

        const existing = input.value.trim();
        input.value = existing ? `${existing} ${data.text}` : data.text;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
        setVoiceStatus(root, '');
      } catch (error) {
        setVoiceStatus(root, 'No pude transcribir el audio. Inténtalo de nuevo.', true);
      } finally {
        button.classList.remove('is-transcribing');
        button.setAttribute('aria-label', 'Dictar mensaje');
        button.setAttribute('title', 'Dictar mensaje');
        setBusy(false);
      }
    };

    const startRecording = async () => {
      if (processing || root.querySelector('[data-chat-shell]')?.getAttribute('aria-busy') === 'true') return;
      try {
        stream = await navigator.mediaDevices.getUserMedia({
          audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true },
        });
        const mimeType = supportedMimeType();
        recorder = mimeType ? new MediaRecorder(stream, { mimeType }) : new MediaRecorder(stream);
        chunks = [];
        startedAt = Date.now();

        recorder.addEventListener('dataavailable', (event) => {
          if (event.data?.size) chunks.push(event.data);
        });
        recorder.addEventListener('stop', async () => {
          const durationMs = Math.max(0, Date.now() - startedAt);
          const blob = new Blob(chunks, { type: recorder?.mimeType || mimeType || 'audio/webm' });
          cleanupStream();
          recorder = null;
          chunks = [];
          await transcribe(blob, durationMs);
        }, { once: true });

        recorder.start(250);
        button.classList.add('is-recording');
        button.setAttribute('aria-label', 'Detener dictado');
        button.setAttribute('title', 'Detener dictado');
        setVoiceStatus(root, 'Escuchando… toca el micrófono para terminar.');
        timeoutId = window.setTimeout(finishRecording, MAX_RECORDING_MS);
      } catch (error) {
        cleanupStream();
        recorder = null;
        button.classList.remove('is-recording');
        setVoiceStatus(root, 'No pude acceder al micrófono. Revisa el permiso del navegador.', true);
      }
    };

    button.addEventListener('click', () => {
      if (processing) return;
      if (recorder?.state === 'recording') {
        finishRecording();
      } else {
        startRecording();
      }
    });

    root.addEventListener('jd:diagnostic:reset', () => {
      if (recorder?.state === 'recording') finishRecording();
    });
  }

  function installVoiceInputs(scope = document) {
    if (scope.matches?.('[data-jd-diagnostic]')) installVoiceInput(scope);
    scope.querySelectorAll?.('[data-jd-diagnostic]').forEach(installVoiceInput);
  }

  function installResponsivePlaceholder(root) {
    if (!root) return;
    const input = root.querySelector('[data-chat-input]');
    if (!input || input.dataset.jdResponsivePlaceholderReady === 'true') return;
    input.dataset.jdResponsivePlaceholderReady = 'true';
    input.dataset.jdDesktopPlaceholder = input.getAttribute('placeholder') || '';

    const mobileQuery = window.matchMedia?.('(max-width: 749px)');
    const applyPlaceholder = () => {
      const mobile = mobileQuery?.matches ?? window.innerWidth <= 749;
      input.setAttribute('placeholder', mobile ? 'Describe qué quieres resolver…' : input.dataset.jdDesktopPlaceholder);
    };

    applyPlaceholder();
    if (mobileQuery?.addEventListener) mobileQuery.addEventListener('change', applyPlaceholder);
    else mobileQuery?.addListener?.(applyPlaceholder);
  }

  function installResponsivePlaceholders(scope = document) {
    if (scope.matches?.('[data-jd-diagnostic]')) installResponsivePlaceholder(scope);
    scope.querySelectorAll?.('[data-jd-diagnostic]').forEach(installResponsivePlaceholder);
  }

  if (!document.getElementById('jd-diagnostic-lead-bridge-style')) {
    const style = document.createElement('style');
    style.id = 'jd-diagnostic-lead-bridge-style';
    style.textContent = `
body .section-business-diagnostic-chat .jd-diagnostic{padding-top:calc(3.2rem + var(--header-height,0px))!important}.jd-diagnostic__inner{display:flex;flex-direction:column}.jd-diagnostic__intro{order:1;max-width:100rem!important;margin-bottom:0!important}.jd-diagnostic__heading{max-width:100rem!important;margin-left:auto!important;margin-right:auto!important;text-align:center!important}.jd-diagnostic__eyebrow,.jd-diagnostic__text,.jd-intent-card--manifesto{display:none!important}.jd-diagnostic__shell{order:2;width:100%;margin-top:1.5rem;margin-bottom:1.4rem}.jd-diagnostic__intent-stage{order:3;width:100%;margin-top:0;margin-bottom:0}
.jd-diagnostic__heading-line{display:block;white-space:nowrap}.jd-diagnostic__heading-line--one{display:block;width:max-content;max-width:100%;margin-inline:auto;min-height:1em;text-align:center}.jd-diagnostic__heading-prefix{display:block;white-space:nowrap}.jd-diagnostic__rotating-slot{display:grid;grid-template-areas:'word';width:max-content;white-space:nowrap;text-align:center;margin:.03em auto}.jd-diagnostic__rotating-sizer,.jd-diagnostic__rotating-word{grid-area:word}.jd-diagnostic__rotating-sizer{visibility:hidden;pointer-events:none}.jd-diagnostic__heading-line--two{margin-top:.02em;text-align:center}.jd-diagnostic__rotating-word{display:inline;white-space:nowrap;justify-self:center}.jd-diagnostic__rotating-word::after{content:'';display:inline-block;width:.055em;height:.82em;margin-left:.08em;background:currentColor;vertical-align:-.04em;animation:jdDiagnosticCaret .82s steps(1,end) infinite}@keyframes jdDiagnosticCaret{0%,48%{opacity:1}49%,100%{opacity:0}}@media(prefers-reduced-motion:reduce){.jd-diagnostic__rotating-word::after{display:none!important}}
@media(min-width:1200px){.jd-intent-card--brand{transform:translate3d(-38rem,5.8rem,0) rotate(-17deg)!important}.jd-intent-card--brand:hover,.jd-intent-card--brand:focus-visible{transform:translate3d(-38rem,3.4rem,0) rotate(-12deg) scale(1.035)!important}.jd-intent-card--web{transform:translate3d(-22rem,1.8rem,0) rotate(-9deg)!important}.jd-intent-card--web:hover,.jd-intent-card--web:focus-visible{transform:translate3d(-22rem,-.6rem,0) rotate(-5deg) scale(1.035)!important}.jd-intent-card--growth{transform:translate3d(-5rem,.5rem,0) rotate(1deg)!important}.jd-intent-card--growth:hover,.jd-intent-card--growth:focus-visible{transform:translate3d(-5rem,-1.9rem,0) rotate(0) scale(1.035)!important}.jd-intent-card--systems{transform:translate3d(13rem,2rem,0) rotate(10deg)!important}.jd-intent-card--systems:hover,.jd-intent-card--systems:focus-visible{transform:translate3d(13rem,-.4rem,0) rotate(6deg) scale(1.035)!important}.jd-intent-card--process{transform:translate3d(29rem,5.8rem,0) rotate(18deg)!important}.jd-intent-card--process:hover,.jd-intent-card--process:focus-visible{transform:translate3d(29rem,3.4rem,0) rotate(12deg) scale(1.035)!important}.jd-intent-card--automation{transform:translate3d(41rem,9rem,0) rotate(24deg)!important}.jd-intent-card--automation:hover,.jd-intent-card--automation:focus-visible{transform:translate3d(41rem,6.2rem,0) rotate(17deg) scale(1.035)!important}}
.jd-diagnostic__composer{grid-template-columns:auto minmax(0,1fr) auto!important;align-items:center!important;gap:.8rem!important;min-height:6.4rem!important;padding:.55rem .65rem!important;border-radius:3.2rem!important}.jd-diagnostic__shell.is-active .jd-diagnostic__composer{border-radius:2.6rem!important}.jd-diagnostic__input{align-self:center!important;min-height:4.4rem!important;max-height:12rem!important;padding:.95rem .2rem!important;line-height:1.45!important}
.jd-diagnostic__mic{width:4.4rem;height:4.4rem;min-width:4.4rem;padding:0;border:0;border-radius:50%;background:transparent;color:#171717;display:inline-flex;align-items:center;justify-content:center;cursor:pointer;transition:background .18s ease,color .18s ease,transform .18s ease,opacity .18s ease}.jd-diagnostic__mic::before{content:'';width:2rem;height:2rem;background:currentColor;-webkit-mask:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 14.5a3.5 3.5 0 0 0 3.5-3.5V6a3.5 3.5 0 1 0-7 0v5a3.5 3.5 0 0 0 3.5 3.5Zm-6-3.5a6 6 0 0 0 12 0M12 17v4M9 21h6' fill='none' stroke='%23000' stroke-width='1.9' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") center/contain no-repeat;mask:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 14.5a3.5 3.5 0 0 0 3.5-3.5V6a3.5 3.5 0 1 0-7 0v5a3.5 3.5 0 0 0 3.5 3.5Zm-6-3.5a6 6 0 0 0 12 0M12 17v4M9 21h6' fill='none' stroke='%23000' stroke-width='1.9' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") center/contain no-repeat}.jd-diagnostic__mic:hover{background:rgba(0,0,0,.055)}.jd-diagnostic__mic.is-recording{background:#171717;color:#fff;animation:jdMicPulse 1.25s ease-in-out infinite}.jd-diagnostic__mic.is-transcribing{opacity:.45;cursor:wait;animation:jdMicSpin 1s linear infinite}.jd-diagnostic__mic:disabled{cursor:wait}.jd-diagnostic__mic:focus-visible{outline:2px solid currentColor;outline-offset:2px}@keyframes jdMicPulse{0%,100%{box-shadow:0 0 0 0 rgba(23,23,23,.12)}50%{box-shadow:0 0 0 .7rem rgba(23,23,23,0)}}@keyframes jdMicSpin{to{transform:rotate(360deg)}}[data-scheme=dark] .jd-diagnostic__mic{color:#fff}[data-scheme=dark] .jd-diagnostic__mic:hover{background:rgba(255,255,255,.08)}[data-scheme=dark] .jd-diagnostic__mic.is-recording{background:#fff;color:#111}
.jd-diagnostic__send{align-self:center!important;width:4.6rem!important;height:4.6rem!important;min-width:4.6rem!important;min-height:4.6rem!important;margin:0!important;padding:0!important;border:0!important;border-radius:50%!important;background:#111!important;color:#fff!important;box-shadow:none!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;gap:0!important;line-height:1!important}[data-scheme=dark] .jd-diagnostic__send{background:#fff!important;color:#111!important;border:0!important;box-shadow:none!important}.jd-diagnostic__send>span{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important}.jd-diagnostic__send::before{content:'';width:2rem;height:2rem;display:block;background-color:currentColor;-webkit-mask:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 20V4M12 4L5.5 10.5M12 4l6.5 6.5' fill='none' stroke='%23000' stroke-width='2.4' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") center/contain no-repeat;mask:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 20V4M12 4L5.5 10.5M12 4l6.5 6.5' fill='none' stroke='%23000' stroke-width='2.4' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") center/contain no-repeat}.jd-diagnostic__send:hover{background:#000!important;transform:translateY(-1px) scale(1.03)!important}[data-scheme=dark] .jd-diagnostic__send:hover{background:#f0f0f0!important}.jd-diagnostic__send:focus-visible{outline:2px solid currentColor!important;outline-offset:3px!important}.jd-diagnostic__send:disabled{opacity:.42!important;transform:none!important}.jd-diagnostic__privacy-note{max-width:98rem;margin:.8rem auto 0;padding:0 1rem;text-align:center;font-size:1.15rem;line-height:1.45;opacity:.5;white-space:nowrap}.jd-diagnostic__privacy-note a{color:inherit;text-decoration:underline;text-underline-offset:.2em;white-space:nowrap}@media(max-width:999px){.jd-diagnostic__privacy-note{white-space:normal}}
@media(max-width:749px){body .section-business-diagnostic-chat .jd-diagnostic{padding-top:calc(2.5rem + var(--header-height,0px))!important}.jd-diagnostic__intro,.jd-diagnostic__heading{max-width:100%!important}.jd-diagnostic__heading-line--one{font-size:.88em;column-gap:.22em}.jd-diagnostic__heading-line--two{white-space:nowrap}.jd-diagnostic__shell{margin-top:1.2rem;margin-bottom:1.5rem}.jd-diagnostic__composer{min-height:5.8rem!important;padding:.45rem .55rem!important;gap:.5rem!important;border-radius:2.9rem!important}.jd-diagnostic__mic{width:4rem;height:4rem;min-width:4rem}.jd-diagnostic__mic::before{width:1.8rem;height:1.8rem}.jd-diagnostic__input{min-height:4rem!important;padding:.8rem .1rem!important}.jd-diagnostic__send{width:4.2rem!important;height:4.2rem!important;min-width:4.2rem!important;min-height:4.2rem!important}.jd-diagnostic__send::before{width:1.85rem;height:1.85rem}.jd-diagnostic__privacy-note{margin-top:.7rem;font-size:1.05rem}}

/* JD_TABLET_CARDS_V1 */
@media (min-width:750px) and (max-width:1199px){
  .section-business-diagnostic-chat .jd-diagnostic__intent-stage{margin-top:.8rem!important;margin-bottom:1rem!important}
  .section-business-diagnostic-chat .jd-diagnostic__deck{height:27rem!important;max-width:78rem!important;margin-inline:auto!important;overflow:visible!important}
  .section-business-diagnostic-chat .jd-intent-card:not(.jd-intent-card--manifesto){width:14.5rem!important;height:20rem!important;margin-left:-7.25rem!important;top:1.1rem!important;padding:1.35rem!important;border-radius:1.1rem!important;transform-origin:50% 100%!important}
  .section-business-diagnostic-chat .jd-intent-card__title{font-size:2rem!important;line-height:.94!important}
  .section-business-diagnostic-chat .jd-intent-card__meta{font-size:1rem!important;line-height:1.22!important}
  .section-business-diagnostic-chat .jd-intent-card__index{font-size:.95rem!important}
  .section-business-diagnostic-chat .jd-intent-card--brand{transform:translate3d(-27rem,5.2rem,0) rotate(-14deg)!important;z-index:1!important}
  .section-business-diagnostic-chat .jd-intent-card--web{transform:translate3d(-17rem,2.1rem,0) rotate(-7deg)!important;z-index:3!important}
  .section-business-diagnostic-chat .jd-intent-card--growth{transform:translate3d(-6rem,.7rem,0) rotate(-2deg)!important;z-index:6!important}
  .section-business-diagnostic-chat .jd-intent-card--systems{transform:translate3d(6rem,.9rem,0) rotate(3deg)!important;z-index:5!important}
  .section-business-diagnostic-chat .jd-intent-card--process{transform:translate3d(17rem,2.5rem,0) rotate(8deg)!important;z-index:3!important}
  .section-business-diagnostic-chat .jd-intent-card--automation{transform:translate3d(27rem,5.3rem,0) rotate(14deg)!important;z-index:1!important}
  .section-business-diagnostic-chat .jd-intent-card--brand:hover,.section-business-diagnostic-chat .jd-intent-card--brand:focus-visible{transform:translate3d(-27rem,3.8rem,0) rotate(-10deg) scale(1.025)!important}
  .section-business-diagnostic-chat .jd-intent-card--web:hover,.section-business-diagnostic-chat .jd-intent-card--web:focus-visible{transform:translate3d(-17rem,.7rem,0) rotate(-4deg) scale(1.025)!important}
  .section-business-diagnostic-chat .jd-intent-card--growth:hover,.section-business-diagnostic-chat .jd-intent-card--growth:focus-visible{transform:translate3d(-6rem,-.7rem,0) rotate(-1deg) scale(1.025)!important}
  .section-business-diagnostic-chat .jd-intent-card--systems:hover,.section-business-diagnostic-chat .jd-intent-card--systems:focus-visible{transform:translate3d(6rem,-.5rem,0) rotate(2deg) scale(1.025)!important}
  .section-business-diagnostic-chat .jd-intent-card--process:hover,.section-business-diagnostic-chat .jd-intent-card--process:focus-visible{transform:translate3d(17rem,1.1rem,0) rotate(5deg) scale(1.025)!important}
  .section-business-diagnostic-chat .jd-intent-card--automation:hover,.section-business-diagnostic-chat .jd-intent-card--automation:focus-visible{transform:translate3d(27rem,3.9rem,0) rotate(10deg) scale(1.025)!important}
  .section-business-diagnostic-chat .jd-diagnostic__deck-hint{margin-top:-.4rem!important}
}

/* JD_DARK_COMPOSER_V2 */
[data-scheme=dark] .section-business-diagnostic-chat .jd-diagnostic__composer{background:rgba(37,38,41,.96)!important;border:1px solid rgba(255,255,255,.11)!important;box-shadow:0 1.4rem 4.2rem rgba(0,0,0,.28),0 0 0 .1rem rgba(255,255,255,.035),inset 0 1px 0 rgba(255,255,255,.055)!important;backdrop-filter:blur(18px)!important;-webkit-backdrop-filter:blur(18px)!important}
[data-scheme=dark] .section-business-diagnostic-chat .jd-diagnostic__composer:focus-within{background:rgba(41,42,45,.98)!important;border-color:rgba(255,255,255,.18)!important;box-shadow:0 1.6rem 4.8rem rgba(0,0,0,.34),0 0 0 .1rem rgba(255,255,255,.07),inset 0 1px 0 rgba(255,255,255,.075)!important}
[data-scheme=dark] .section-business-diagnostic-chat .jd-diagnostic__input{color:#f6f6f7!important}
[data-scheme=dark] .section-business-diagnostic-chat .jd-diagnostic__input::placeholder{color:rgba(246,246,247,.52)!important}
[data-scheme=dark] .section-business-diagnostic-chat .jd-diagnostic__mic{color:rgba(255,255,255,.82)!important}
[data-scheme=dark] .section-business-diagnostic-chat .jd-diagnostic__mic:hover{background:rgba(255,255,255,.075)!important;color:#fff!important}
[data-scheme=dark] .section-business-diagnostic-chat .jd-diagnostic__send{background:#f7f7f7!important;color:#111!important}
[data-scheme=dark] .section-business-diagnostic-chat .jd-diagnostic__send:hover{background:#fff!important}
@media(prefers-color-scheme:dark){
  [data-scheme=auto] .section-business-diagnostic-chat .jd-diagnostic__composer{background:rgba(37,38,41,.96)!important;border:1px solid rgba(255,255,255,.11)!important;box-shadow:0 1.4rem 4.2rem rgba(0,0,0,.28),0 0 0 .1rem rgba(255,255,255,.035),inset 0 1px 0 rgba(255,255,255,.055)!important;backdrop-filter:blur(18px)!important;-webkit-backdrop-filter:blur(18px)!important}
  [data-scheme=auto] .section-business-diagnostic-chat .jd-diagnostic__composer:focus-within{background:rgba(41,42,45,.98)!important;border-color:rgba(255,255,255,.18)!important;box-shadow:0 1.6rem 4.8rem rgba(0,0,0,.34),0 0 0 .1rem rgba(255,255,255,.07),inset 0 1px 0 rgba(255,255,255,.075)!important}
  [data-scheme=auto] .section-business-diagnostic-chat .jd-diagnostic__input{color:#f6f6f7!important}
  [data-scheme=auto] .section-business-diagnostic-chat .jd-diagnostic__input::placeholder{color:rgba(246,246,247,.52)!important}
  [data-scheme=auto] .section-business-diagnostic-chat .jd-diagnostic__mic{color:rgba(255,255,255,.82)!important}
  [data-scheme=auto] .section-business-diagnostic-chat .jd-diagnostic__mic:hover{background:rgba(255,255,255,.075)!important;color:#fff!important}
  [data-scheme=auto] .section-business-diagnostic-chat .jd-diagnostic__send{background:#f7f7f7!important;color:#111!important}
  [data-scheme=auto] .section-business-diagnostic-chat .jd-diagnostic__send:hover{background:#fff!important}
}
`;
    document.head.appendChild(style);
  }

  const initialize = (scope = document) => {
    installPrivacyNotes(scope);
    installHeadingAnimations(scope);
    installResponsivePlaceholders(scope);
    installVoiceInputs(scope);
  };

  document.addEventListener('click', (event) => {
    if (event.target?.closest?.('[data-chat-reset]')) {
      sessionId = createSessionId();
      document.querySelectorAll('[data-jd-diagnostic]').forEach((root) => root.dispatchEvent(new Event('jd:diagnostic:reset')));
    }
  });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
})();

(() => {
  if (window.jdDiagnosticBridgeLoaderReady) return;
  window.jdDiagnosticBridgeLoaderReady = true;

  const current = document.currentScript?.src || '';
  if (!current) return;

  const assetUrl = (filename) => {
    const url = new URL(current, window.location.href);
    url.pathname = url.pathname.replace(/\/[^/]+$/, `/${filename}`);
    url.search = '';
    url.hash = '';
    return url.toString();
  };

  const load = (filename) => new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = assetUrl(filename);
    script.async = false;
    script.onload = resolve;
    script.onerror = () => reject(new Error(`No se pudo cargar ${filename}`));
    document.head.appendChild(script);
  });

  load('jd-diagnostic-quick-replies.js')
    .then(() => load('jd-diagnostic-calendar.js'))
    .catch((error) => console.error('[JUANDIAZ.MX diagnostic]', error));
})();
